import { Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SignatureSuccessConfirmation } from './SignatureSuccessConfirmation/SignatureSuccessConfirmation';
import type { SignatureSuccessDetails } from './SignatureSuccessConfirmation/SignatureSuccessConfirmation.types';

interface Props {
	successDetails?: SignatureSuccessDetails;
}

export const DoneStep = ({ successDetails }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	if (successDetails) {
		return <SignatureSuccessConfirmation {...successDetails} />;
	}

	return (
		<>
			<Icon variant="sign" size="3xl" />
			<Text>{tCommonUi('eid_easy_signing.signing_complete')}</Text>
		</>
	);
};
